import {Component, Input, ViewChild} from '@angular/core';
import {
  ControlContainer,
  ControlValueAccessor, FormControl,
  FormControlDirective,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";
import {AbstractComponent} from "../abstract.component";

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: InputComponent,
    multi: true
  },
  ]
})
export class InputComponent extends AbstractComponent implements ControlValueAccessor {
  @Input() type: 'text' | 'password' | 'number' | 'decimal' = "text";
  @Input() formId?: string;
  @Input() label?: string;
  @Input() placeholder?: string;
  @Input() translatedLabel?: string;
  @Input() translatedPlaceholder?: string;
  @Input() cssClass?: string;
  @Input() min?: number | string | null = null;
  @Input() max?: number | string | null = null;
  @Input() autocomplete?: string;
  @Input() hideErrorMessage?: boolean;
  @Input() readonly: boolean = false;
  @Input() labelIsVisible: boolean = true;

  errorMessages: string[] = [];

  constructor(private controlContainer: ControlContainer) {
    super();
  }

  @ViewChild(FormControlDirective, {static: true}) formControlDirective?: FormControlDirective;

  @Input() formControlName?: string;

  // get hold of FormControl instance no matter formControl or formControlName is given.
  // If formControlName is given, then this.controlContainer.control is the parent FormGroup (or FormArray) instance.
  get control(): FormControl {
    return <FormControl<any>>this.controlContainer!.control!.get(this.formControlName!);
  }

  registerOnTouched(fn: any): void {
    this.formControlDirective?.valueAccessor?.registerOnTouched(fn);
  }

  registerOnChange(fn: any): void {
    this.formControlDirective?.valueAccessor?.registerOnChange(fn);
  }

  writeValue(obj: any): void {
    this.formControlDirective?.valueAccessor?.writeValue(obj);
  }

  setDisabledState(isDisabled: boolean): void {
    this.formControlDirective?.valueAccessor?.setDisabledState!(isDisabled);
  }

}
